<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .files-container {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);
    margin-top: utils.in_rem(16px);

    .header-container {
      display: flex;
      justify-content: flex-end;
      margin-bottom: utils.in_rem(16px);
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { saveCandidate } from "@sourcewhale/shared/src/svelte/api/candidates";
  import FilesTable from "../../../tables/FilesTable/FilesTable.svelte";
  import {
    activePopUpModalStore,
    candidateFileIdsStore,
    candidateFilesStore,
    candidateStore,
  } from "../stores";

  const deleteCallback = async (fileId) => {
    const updatedFileIds = $candidateFileIdsStore.filter((id) => id !== fileId);
    await saveCandidate({
      candidateId: $candidateStore.candidateId,
      fileIds: updatedFileIds,
    });
  };
</script>

<div class="files-container">
  <div class="header-container">
    <Button
      type="button"
      leadingIcon="fa-regular fa-plus"
      onclick={() => {
        activePopUpModalStore.set({ modal: "addFile" });
      }}
      aria-label="Add Files"
    >
      Add Files
    </Button>
  </div>

  <FilesTable filesStore={candidateFilesStore} {deleteCallback} />
</div>
